import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileChartPie,
  faMoneyBillTrendUp,
} from '@fortawesome/pro-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const content = {
  es: {
    title: 'Impacto Total Economico medio en las empresas',
    button: 'Revisar Informes',
  },
  en: {
    title: 'Average Total Economic Impact on Business',
    button: 'Review Reports',
  },
};

const EconomicImpactStats = ({ stats = [], language = 'es' }) => {
  const navigate = useNavigate();
  const lang = content[language] || content.es;

  const styles = {
    statsSection: {
      backgroundColor: '#0F172A',
      color: '#FFF',
      padding: '60px 20px',
      textAlign: 'center',
    },
    statsTitle: {
      fontSize: '32px',
      fontWeight: 'bold',
      marginBottom: '40px',
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    statsGrid: {
      display: 'flex',
      justifyContent: 'center',
      gap: '60px',
      flexWrap: 'wrap',
    },
    statItem: {
      minWidth: '150px',
    },
    statNumber: {
      fontSize: '48px',
      fontWeight: 'bold',
      marginBottom: '8px',
    },
    statDesc: {
      fontSize: '20px',
      fontWeight: '400',
      lineHeight: '1.4',
      color: '#FF4D4D',
      maxWidth: '180px',
      margin: '0 auto',
    },
    button: {
      marginTop: '40px',
      display: 'inline-flex',
      alignItems: 'center',
      padding: '12px 24px',
      borderRadius: '24px',
      backgroundColor: '#ffffff',
      color: '#0F172A',
      fontSize: '16px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
    },
    icon: {
      marginRight: '8px',
      fontSize: '50px',
      color: '#FFFFFF',
    },
    icon1: {
      marginRight: '8px',
    },
  };

  return (
    <section style={styles.statsSection}>
      <FontAwesomeIcon icon={faMoneyBillTrendUp} style={styles.icon} />
      <h3 className="H3" style={styles.statsTitle}>
        {lang.title}
      </h3>

      <div style={styles.statsGrid}>
        {stats.map((item, index) => (
          <div key={index} style={styles.statItem}>
            <div style={styles.statNumber}>{item.number}</div>
            <div style={styles.statDesc}>{item.desc}</div>
          </div>
        ))}
      </div>

      <button style={styles.button} onClick={() => navigate('/library')}>
        <FontAwesomeIcon icon={faFileChartPie} style={styles.icon1} />
        {lang.button}
      </button>
    </section>
  );
};

export default EconomicImpactStats;
